import { render, staticRenderFns } from "./ConstructorStandings.vue?vue&type=template&id=41be230a&scoped=true&"
import script from "./ConstructorStandings.vue?vue&type=script&lang=js&"
export * from "./ConstructorStandings.vue?vue&type=script&lang=js&"
import style0 from "./ConstructorStandings.vue?vue&type=style&index=0&id=41be230a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be230a",
  null
  
)

export default component.exports